import { render, staticRenderFns } from "./BloqueioNotas.vue?vue&type=template&id=7bbf21fa"
import script from "./BloqueioNotas.vue?vue&type=script&lang=js"
export * from "./BloqueioNotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports